/**
 * <s-bundle-picker> — syncs the product form's hidden quantity and selling_plan inputs with the chosen bundle box
 * and the "automatic refills" switch, and mirrors the switch in data-mode ("subscribe" | "once") so CSS can
 * show subscription or one-time pricing.
 * Markup: [data-bundle-quantity] and [data-bundle-plan] hidden inputs, input[name="bundle"] radios carrying
 * data-quantity and data-plan, and an optional [data-refill] checkbox.
 */
class SBundlePicker extends HTMLElement {
  connectedCallback() {
    this.quantityInput = this.querySelector('[data-bundle-quantity]');
    this.planInput = this.querySelector('[data-bundle-plan]');
    this.refill = this.querySelector('[data-refill]');
    this.onChange = () => this.sync();
    this.addEventListener('change', this.onChange);
    this.sync();
  }

  disconnectedCallback() {
    this.removeEventListener('change', this.onChange);
  }

  sync() {
    const subscribe = this.refill ? this.refill.checked : false;
    this.dataset.mode = subscribe ? 'subscribe' : 'once';
    // Free eBook line property: only sent with subscription bundles (disabled inputs are left out of the form data).
    const ebook = this.querySelector('[data-bundle-ebook]');
    if (ebook) ebook.disabled = !subscribe;
    const picked = this.querySelector('input[name="bundle"]:checked');
    if (!picked) return;
    if (this.quantityInput) this.quantityInput.value = picked.dataset.quantity || '1';
    if (this.planInput) this.planInput.value = subscribe ? picked.dataset.plan || '' : '';
  }
}

if (!customElements.get('s-bundle-picker')) customElements.define('s-bundle-picker', SBundlePicker);
